import { SwCheckForUpdateService } from '@one/app/shared/services/sw/sw-check-for-update.service';
import { SwLogUpdateService } from '@one/app/shared/services/sw/sw-log-update.service';
import { SwReloadOnUpdateService } from '@one/app/shared/services/sw/sw-reload-on-update.service';
import { SwStoragePersistenceService } from '@one/app/shared/services/sw/sw-storage-persistence.service';
import { SwUnrecoverableStateService } from '@one/app/shared/services/sw/sw-unrecoverable-state.service';

/**
 * @description
 * Starts every service worker side concern once the app has bootstrapped.
 * @param {SwLogUpdateService} swLogUpdateService logs the available and current versions
 * @param {SwReloadOnUpdateService} swReloadOnUpdateService reloads the app when a new version is ready
 * @param {SwCheckForUpdateService} swCheckForUpdateService polls for new versions
 * @param {SwUnrecoverableStateService} swUnrecoverableStateService repairs a worker that can no longer serve itself
 * @param {SwStoragePersistenceService} swStoragePersistenceService keeps caches and offline data safe from eviction
 * @returns {Function} the bootstrap listener
 */
export function serviceWorkerFactory(
  swLogUpdateService: SwLogUpdateService,
  swReloadOnUpdateService: SwReloadOnUpdateService,
  swCheckForUpdateService: SwCheckForUpdateService,
  swUnrecoverableStateService: SwUnrecoverableStateService,
  swStoragePersistenceService: SwStoragePersistenceService
): () => void {
  return (): void => {
    swLogUpdateService.init();
    swCheckForUpdateService.init();
    swReloadOnUpdateService.init();
    swUnrecoverableStateService.init();
    swStoragePersistenceService.init();
  };
}
